(() => {
  // ---- selectors you actually have (from your screenshot) ----
  const SELECTORS = {
    count: "[data-cart-button-count]",
    total: "[data-cart-button-total]",
  };

  // ---- helpers ----
  function stripHtml(input) {
    return String(input || "").replace(/<[^>]*>/g, "").trim();
  }

  async function getCart() {
    const r = await fetch("/cart.js", { credentials: "same-origin" });
    if (!r.ok) throw new Error("cart.js failed");
    return r.json();
  }

  function formatMoneyPlain(cents) {
    let out = null;

    if (window.Shopify?.formatMoney) {
      const fmt =
        (window.theme && (window.theme.moneyFormat || window.theme.money_format)) ||
        "${{amount}}";
      try {
        out = window.Shopify.formatMoney(cents, fmt);
      } catch (e) {
        out = null;
      }
    }

    if (!out) out = `$${(cents / 100).toFixed(2)}`;
    return stripHtml(out);
  }

  async function updateHeader() {
    const cart = await getCart();

    // count
    document.querySelectorAll(SELECTORS.count).forEach((el) => {
      el.textContent = String(cart.item_count || 0);
    });

    // total
    // const money = formatMoneyPlain(cart.total_price || 0);
    // document.querySelectorAll(SELECTORS.total).forEach((el) => {
    //   const transcy = el.querySelector(".transcy-money");
    //   if (transcy) transcy.textContent = money;
    //   else el.textContent = money;
    // });
  }

  let timer;
  function syncAll() {
    clearTimeout(timer);
    timer = setTimeout(async () => {
      try {
        await updateHeader();
        // Run again after Transcy/theme touches DOM
        setTimeout(() => updateHeader().catch(() => {}), 600);
      } catch (e) {}
    }, 120);
  }

  function isCartEndpoint(url) {
    if (!url) return false;
    return (
      url.includes("/cart/add") ||
      url.includes("/cart/add.js") ||
      url.includes("/cart/change") ||
      url.includes("/cart/change.js") ||
      url.includes("/cart/update") ||
      url.includes("/cart/update.js")
    );
  }

  // ---- 1) Hook FETCH ----
  const _fetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await _fetch.apply(this, args);
    try {
      const url =
        typeof args[0] === "string"
          ? args[0]
          : (args[0] && args[0].url) || "";
      if (isCartEndpoint(url)) syncAll();
    } catch (e) {}
    return res;
  };

  // ---- 2) Hook XHR (this is what your quick add is likely using) ----
  const _open = XMLHttpRequest.prototype.open;
  const _send = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__cartSyncUrl = url;
    return _open.call(this, method, url, ...rest);
  };

  XMLHttpRequest.prototype.send = function (...args) {
    this.addEventListener("loadend", () => {
      try {
        if (isCartEndpoint(this.__cartSyncUrl || "")) syncAll();
      } catch (e) {}
    });
    return _send.apply(this, args);
  };

  // ---- 3) Hook normal form submits to /cart/add ----
  document.addEventListener(
    "submit",
    (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;

      const action = (form.getAttribute("action") || "").toLowerCase();
      if (action.includes("/cart/add")) {
        setTimeout(syncAll, 250);
      }
    },
    true
  );

  // Initial
  syncAll();
})();
